

// src/api/axiosClient.js
import axios from 'axios';

// Get API URL from environment variable
// React automatically loads .env files based on NODE_ENV
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

console.log('🌍 Environment:', process.env.NODE_ENV);
console.log('🔗 API URL:', API_URL);

const axiosClient = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
axiosClient.interceptors.request.use(
  (config) => {
    console.log(`🚀 [${config.method?.toUpperCase()}] ${config.baseURL}${config.url}`);
    
    // Add token from localStorage
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('🔑 Added Authorization header');
    }
    
    return config;
  },
  (error) => {
    console.error('❌ Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
axiosClient.interceptors.response.use(
  (response) => {
    console.log('✅ Response received:', {
      status: response.status,
      url: response.config.url,
    });
    return response.data;
  },
  (error) => {
    console.error('❌ API Error:', {
      status: error.response?.status,
      url: error.config?.url,
      message: error.message
    });
    
    const message = error.response?.data?.message || error.message || 'Request failed';
    return Promise.reject(new Error(message));
  }
);

export default axiosClient;